import React from 'react'
import {
  HeaderContainer,
  HeaderContent,
  PageTitle,
  PageSubtitle,
  ScoreDisplayWrapper,
} from './AnalysisSectionHeader.styles'

export interface AnalysisSectionHeaderProps {
  title: string
  subtitle?: React.ReactNode
  score?: {
    value: number
    maxValue?: number
    label?: string
    variant?: 'success' | 'warning' | 'danger' | 'default' | 'primary'
    tooltip?: string
    showProgress?: boolean
  }
  children?: React.ReactNode
}

export const AnalysisSectionHeader: React.FC<AnalysisSectionHeaderProps> = ({
  title,
  subtitle,
  score,
  children,
}) => {
  return (
    <HeaderContainer>
      <HeaderContent>
        <PageTitle>{title}</PageTitle>
        {subtitle && <PageSubtitle>{subtitle}</PageSubtitle>}
      </HeaderContent>
      {score && (
        <ScoreDisplayWrapper
          value={score.value}
          maxValue={score.maxValue || 100}
          label={score.label || ''}
          variant={score.variant}
          tooltip={score.tooltip}
          showProgress={score.showProgress}
        />
      )}
      {children}
    </HeaderContainer>
  )
}
